module.exports = __webpack_public_path__ + "static/media/abhishek_m.08b50705.jpg";